import getProject from "../../services/getters/project_getters/get_project";
import loadProject from "../../actions/react_query/projects/load_project";
import useQueryWithState from "../use_query_with_state";

import type Project from "../../models/domain/project";

// While a project is locked (e.g. a data import is running) poll it, so the lock clears automatically
// once the server unlocks the project. This also makes the lock survive a page reload: after a reload
// the import's own completion poll is gone, but re-fetching the project here re-locks the UI and keeps
// polling until the import finishes. When the project is unlocked, no polling happens.
export const IMPORT_LOCK_POLL_INTERVAL_MS = 5000;
export const lockedProjectRefetchInterval = (project?: Project | null): number | false => (
  project?.isLocked ? IMPORT_LOCK_POLL_INTERVAL_MS : false
);

const useProject = (projectId: string) => {
  return useQueryWithState(["useProject", projectId], loadProject, getProject, { enabled: !!projectId, refetchInterval: lockedProjectRefetchInterval }, { projectId }, projectId);
};

export default useProject;
